import type { EventDto } from '@/shared/types/domain';

interface EventSelectorProps {
  events: EventDto[];
  eventId: string | null;
  onChange: (eventId: string) => void;
}

export function EventSelector({ events, eventId, onChange }: EventSelectorProps) {
  if (events.length === 0) return null;

  return (
    <select
      className="field__input"
      style={{ minHeight: 40, width: 'auto' }}
      value={eventId ?? ''}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Select event"
    >
      {events.map((event) => (
        <option key={event.id} value={event.id}>
          {event.name}
        </option>
      ))}
    </select>
  );
}
